import request from '../request';

interface SpuReqOptions {
  shopCode: string;
  spuCode?: string;
  skuCode?: string;
}

/** 获取商品详情 */
export async function getSpuDetail(params: SpuReqOptions) {
  return request<API.CommonResponse<API.SpuInfoVO>>({
    url: '/api/mall/rest/product/spu/detail/spuCode',
    method: 'POST',
    data: params,
  });
}

/** 获取商品详情 */
export async function getComSpuDetail(params: SpuReqOptions) {
  return request<API.CommonResponse<API.SpuDetailVO>>({
    url: '/api/mall/rest/product/spu/detail',
    method: 'POST',
    data: params,
    headers: { authLogin: true },
  });
}

/** SPU可用商品的属性值集合 */
export async function getSkuProperties(params: {
  shopCode: string;
  skuCode?: string;
}) {
  return request<API.CommonResponse<API.ProductAvailableValueVO>>({
    url: '/api/mall/rest/product/available/sku/property/value/list',
    method: 'POST',
    data: params,
  });
}

// 批量获取阶梯价
export async function getSkuLadderPrice(skuCodes?: any[]) {
  return request<API.CommonResponse<any[]>>({
    url: '/api/mall/rest/promotion/ladderPrice/list',
    method: 'POST',
    data: { skuCodes },
    headers: { authLogin: true },
  });
}
